import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FadeIn from 'react-fade-in';
import IconHeart2 from 'components/icons/iconHeart2';
import VideoPlayIconWrapper from 'components/consumer/VideoPlayIconWrapper/VideoPlayIconWrapper';
import MobileModal from 'components/consumer/MobileModal';
import JBImage from 'components/essentials/JBImage';
import isClient from 'commons/isClient';
import IconLightningBoltFilled from 'components/icons/IconLightningBoltFilled';
import { colorYellow } from 'styles/layout/colors';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import useScreen from 'hooks/useScreen';
import ProtectionPlanVariant from './ProtectionPlanVariant';
const FlyoutContainer = t0 => {
  const $ = _c(72);
  const {
    align: t1,
    className: t2,
    content,
    fallbackSrc,
    flyoutVariant: t3,
    headerBgColor: t4,
    imageUrl,
    isInFlashSale: t5,
    isOpen,
    left,
    mobileContentNoPadding: t6,
    onClose,
    protectionPlan: t7,
    showAboveOnDesktop: t8,
    showFavIcon,
    subSubTitle,
    subTitle,
    title,
    titleExtra,
    titleInfo,
    top,
    useCoordsFromProps,
    videoObj
  } = t0;
  const align = t1 === undefined ? "left" : t1;
  const className = t2 === undefined ? "" : t2;
  const flyoutVariant = t3 === undefined ? "standard" : t3;
  const headerBgColor = t4 === undefined ? null : t4;
  const isInFlashSale = t5 === undefined ? false : t5;
  const mobileContentNoPadding = t6 === undefined ? false : t6;
  const protectionPlan = t7 === undefined ? null : t7;
  const showAboveOnDesktop = t8 === undefined ? false : t8;
  const containerRef = useRef(null);
  const [height, setHeight] = useState(300);
  const [isAnimationComplete, setIsAnimationComplete] = useState(false);
  const {
    isMobile,
    isDesktop
  } = useScreen();
  const [isPlaying, setPlaying] = useState(false);
  const videoRef = useRef(null);
  let t10;
  let t9;
  if ($[0] !== isPlaying) {
    t9 = () => {
      if (videoRef.current && isPlaying) {
        videoRef.current.play().catch(_temp);
      }
    };
    t10 = [isPlaying];
    $[0] = isPlaying;
    $[1] = t10;
    $[2] = t9;
  } else {
    t10 = $[1];
    t9 = $[2];
  }
  useEffect(t9, t10);
  let t11;
  let t12;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => {
      setTimeout(() => {
        const theHeight = containerRef.current?.getBoundingClientRect().height;
        if (theHeight) {
          setHeight(theHeight);
        }
        setIsAnimationComplete(true);
      }, 100);
    };
    t12 = [];
    $[3] = t11;
    $[4] = t12;
  } else {
    t11 = $[3];
    t12 = $[4];
  }
  useEffect(t11, t12);
  let absTop = flyoutVariant === "materialSwatch" ? -30 : 0;
  if (top < 0) {
    absTop = -top;
  } else {
    if (isClient() && window.innerHeight < top + height) {
      absTop = window.innerHeight - height - top;
      if (flyoutVariant === "fabricGallery") {
        absTop = absTop - 150;
      }
    }
  }
  let t13;
  if ($[5] !== imageUrl || $[6] !== isPlaying || $[7] !== videoObj) {
    t13 = !imageUrl && videoObj ? <div className={classNames("min-h-[156px] overflow-hidden object-cover w-screen relative lg:w-auto", "[&_video]:w-full")}><video className="FlyoutContainer__video" poster={videoObj.src} ref={videoRef} controls={videoObj.controls === false ? videoObj.controls : isPlaying} autoPlay={videoObj.autoPlay} muted={videoObj.autoPlay} loop={videoObj.loop} onClick={() => setPlaying(!isPlaying)} onPause={() => setPlaying(false)} key={videoObj.link} playsInline="playsinline"><track kind="captions" /><source src={videoObj.link} type="video/mp4" />Your browser does not support the video tag.</video>{!videoObj.autoPlay && !isPlaying && <VideoPlayIconWrapper onClick={() => setPlaying(true)} />}</div> : null;
    $[5] = imageUrl;
    $[6] = isPlaying;
    $[7] = videoObj;
    $[8] = t13;
  } else {
    t13 = $[8];
  }
  const videoContent = t13;
  let t14;
  if ($[9] !== fallbackSrc || $[10] !== headerBgColor || $[11] !== imageUrl || $[12] !== isMobile || $[13] !== showFavIcon) {
    t14 = imageUrl && !isMobile && <div className={classNames("relative lg:w-auto [&_img]:h-[156px]", "[&_svg]:absolute [&_svg]:bottom-4 [&_svg]:right-4", {
      "w-screen [&_img]:object-cover": headerBgColor !== "grey",
      "w-auto [&_img]:object-contain px-0 py-2 bg-gray-light7": headerBgColor === "grey"
    })}><JBImage src={imageUrl} fallbackSrc={fallbackSrc} width={400} loader={false} lazy={false} />{showFavIcon ? <IconHeart2 color="white" fill="white" /> : null}</div>;
    $[9] = fallbackSrc;
    $[10] = headerBgColor;
    $[11] = imageUrl;
    $[12] = isMobile;
    $[13] = showFavIcon;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  const t15 = !imageUrl && videoObj && !isMobile && videoContent;
  let t16;
  if ($[15] !== isInFlashSale) {
    t16 = !!isInFlashSale && <div className="items-center flex mb-2"><IconLightningBoltFilled className="mr-[5px]" color={colorYellow} height={13} width={12} /><span className="text-xs font-bold text-gray text-left">Hurry - save big on this flash sale!</span></div>;
    $[15] = isInFlashSale;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] !== titleExtra) {
    t17 = titleExtra ? <span className="text-lg font-bold ml-1">{titleExtra}</span> : null;
    $[17] = titleExtra;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  let t18;
  if ($[19] !== t17 || $[20] !== title) {
    t18 = <span className="text-xl font-bold">{title}{t17}</span>;
    $[19] = t17;
    $[20] = title;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] !== titleInfo) {
    t19 = titleInfo ? <span className="text-base font-bold ml-1.5">({titleInfo})</span> : null;
    $[22] = titleInfo;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  let t20;
  if ($[24] !== t18 || $[25] !== t19) {
    t20 = <div className="flex">{t18}{t19}</div>;
    $[24] = t18;
    $[25] = t19;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== subSubTitle || $[28] !== subTitle) {
    t21 = !!subTitle || !!subSubTitle ? <div className="mb-4">{subTitle ? <span> {subTitle} </span> : null}{subSubTitle ? <div className="FlyoutContainer__subSubTitle">{" "}{subSubTitle}{" "}</div> : null}</div> : null;
    $[27] = subSubTitle;
    $[28] = subTitle;
    $[29] = t21;
  } else {
    t21 = $[29];
  }
  let t22;
  if ($[30] !== content) {
    t22 = <div className="text-xs text-gray text-left">{content}</div>;
    $[30] = content;
    $[31] = t22;
  } else {
    t22 = $[31];
  }
  let t23;
  if ($[32] !== t16 || $[33] !== t20 || $[34] !== t21 || $[35] !== t22) {
    t23 = <div className="text-xs pt-6 px-2 pb-0 lg:border lg:border-solid lg:border-gray-light7 lg:rounded-bl-lg lg:rounded-br-lg lg:p-8">{t16}{t20}{t21}{t22}</div>;
    $[32] = t16;
    $[33] = t20;
    $[34] = t21;
    $[35] = t22;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  let t24;
  if ($[37] !== t14 || $[38] !== t15 || $[39] !== t23) {
    t24 = <>{t14}{t15}{t23}</>;
    $[37] = t14;
    $[38] = t15;
    $[39] = t23;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  const containerContent = t24;
  if (isMobile) {
    let t25;
    if ($[41] !== fallbackSrc || $[42] !== headerBgColor || $[43] !== imageUrl || $[44] !== showFavIcon || $[45] !== videoContent || $[46] !== videoObj) {
      t25 = imageUrl ? <div className={classNames("relative lg:w-auto [&_img]:h-[156px]", "[&_svg]:absolute [&_svg]:bottom-4 [&_svg]:right-4", {
        "w-screen [&_img]:object-cover": headerBgColor !== "grey",
        "w-auto [&_img]:object-contain px-0 py-2 bg-gray-light7": headerBgColor === "grey"
      })}><JBImage src={imageUrl} fallbackSrc={fallbackSrc} width={400} loader={false} lazy={false} />{showFavIcon ? <IconHeart2 color="white" fill="white" /> : null}</div> : !imageUrl && videoObj ? videoContent : null;
      $[41] = fallbackSrc;
      $[42] = headerBgColor;
      $[43] = imageUrl;
      $[44] = showFavIcon;
      $[45] = videoContent;
      $[46] = videoObj;
      $[47] = t25;
    } else {
      t25 = $[47];
    }
    const finalContentUnderHeader = t25;
    let t26;
    if ($[48] !== className || $[49] !== containerContent || $[50] !== finalContentUnderHeader || $[51] !== isOpen || $[52] !== mobileContentNoPadding || $[53] !== onClose) {
      t26 = <MobileModal headerCenter="" isFullHeight={false} isOpen={isOpen} onClose={onClose} contentNoPadding={mobileContentNoPadding} contentUnderHeader={finalContentUnderHeader} className={className}>{containerContent}</MobileModal>;
      $[48] = className;
      $[49] = containerContent;
      $[50] = finalContentUnderHeader;
      $[51] = isOpen;
      $[52] = mobileContentNoPadding;
      $[53] = onClose;
      $[54] = t26;
    } else {
      t26 = $[54];
    }
    return t26;
  }
  const showAbove = isDesktop && showAboveOnDesktop;
  const horizontalOffset = showAbove && isAnimationComplete ? -290 : undefined;
  const t25 = align !== "right";
  const t26 = align === "right";
  let t27;
  if ($[55] !== className || $[56] !== t25 || $[57] !== t26) {
    t27 = classNames("w-[400px] min-h-[255px] bg-white ml-[1.9rem] rounded-lg overflow-hidden lg:absolute lg:z-10 lg:top-0", className, {
      "lg:left-[-450px]": t25,
      "left-auto right-[-430px]": t26
    });
    $[55] = className;
    $[56] = t25;
    $[57] = t26;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  const t28 = showAbove && !isAnimationComplete ? "hidden" : undefined;
  const t29 = useCoordsFromProps ? top : showAbove && isAnimationComplete ? 0 - (height + 38) : absTop;
  const t30 = useCoordsFromProps ? left : align === "left" ? horizontalOffset : undefined;
  const t31 = align === "right" ? horizontalOffset : undefined;
  let t32;
  if ($[59] !== t28 || $[60] !== t29 || $[61] !== t30 || $[62] !== t31) {
    t32 = {
      visibility: t28,
      top: t29,
      left: t30,
      right: t31
    };
    $[59] = t28;
    $[60] = t29;
    $[61] = t30;
    $[62] = t31;
    $[63] = t32;
  } else {
    t32 = $[63];
  }
  let t33;
  if ($[64] !== containerContent || $[65] !== flyoutVariant || $[66] !== protectionPlan) {
    t33 = flyoutVariant === "protectionPlan" && protectionPlan ? <ProtectionPlanVariant {...protectionPlan} /> : containerContent;
    $[64] = containerContent;
    $[65] = flyoutVariant;
    $[66] = protectionPlan;
    $[67] = t33;
  } else {
    t33 = $[67];
  }
  let t34;
  if ($[68] !== t27 || $[69] !== t32 || $[70] !== t33) {
    t34 = <div className="relative z-[1]"><FadeIn><div ref={containerRef} className={t27} style={t32}>{t33}</div></FadeIn></div>;
    $[68] = t27;
    $[69] = t32;
    $[70] = t33;
    $[71] = t34;
  } else {
    t34 = $[71];
  }
  return t34;
};
FlyoutContainer.propTypes = {
  align: PropTypes.oneOf(['left', 'right']),
  className: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  fallbackSrc: PropTypes.string,
  flyoutVariant: PropTypes.oneOf(['materialSwatch', 'protectionPlan', 'standard']),
  headerBgColor: PropTypes.oneOf(['grey']),
  imageUrl: PropTypes.string,
  isInFlashSale: PropTypes.bool,
  isOpen: PropTypes.bool,
  left: PropTypes.bool,
  mobileContentNoPadding: PropTypes.bool,
  onClose: PropTypes.func,
  protectionPlan: PropTypes.shape({
    backgroundImg: PropTypes.string,
    planItems: PropTypes.arrayOf(PropTypes.string),
    planName: PropTypes.string,
    planType: PropTypes.oneOf(['protection', 'pet'])
  }),
  showAboveOnDesktop: PropTypes.bool,
  showFavIcon: PropTypes.bool,
  subSubTitle: PropTypes.string,
  subTitle: PropTypes.node,
  title: PropTypes.string,
  titleExtra: PropTypes.string,
  titleInfo: PropTypes.string,
  top: PropTypes.number,
  useCoordsFromProps: PropTypes.bool,
  videoObj: PropTypes.shape({
    autoPlay: PropTypes.bool,
    controls: PropTypes.object,
    link: PropTypes.string,
    loop: PropTypes.bool,
    src: PropTypes.string
  })
};
export default withBrowserOnly(FlyoutContainer);
function _temp(error) {
  throw new Error(`Video play failed: ${error.message}`);
}